import { CustomTheme } from '@nemuru-eng/js-api-client';

import nemuruTheme from '@/config/themes/themes/nemuruTheme';

import { Theme } from '../types';

const modules = import.meta.glob('./themes/*.ts');

export const getTheme = async (
  themeName: CustomTheme,
  darkMode: boolean = false,
): Promise<{ theme: Partial<Theme>; darkMode: boolean }> => {
  let theme: Partial<Theme> = nemuruTheme;

  const candidateThemes: Partial<Theme>[] = [];

  for (const key of Object.keys(modules)) {
    const module = (await modules[key]()) as { default: Partial<Theme> };
    if (module && module.default && module.default.themeName === themeName) {
      candidateThemes.push(module.default);
    }
  }

  if (candidateThemes.length === 0) {
    return { theme, darkMode };
  }

  let candidateTheme: Partial<Theme> | undefined;

  if (darkMode) {
    candidateTheme = candidateThemes.find((theme) => theme.palette?.type === 'dark');
  } else {
    candidateTheme = candidateThemes.find((theme) => theme.palette?.type === 'light' || !theme.palette?.type);
  }

  if (!candidateTheme) {
    theme = candidateThemes[0];
  }

  return { theme: candidateTheme ?? theme, darkMode };
};
